import React from "react";
import UserDashboard from "./UserDashboard";

const UserDashboardContainer = () => {
    return (
        <>
            <UserDashboard />
        </>
    );
};

export default UserDashboardContainer;
